export const microsoftGraphKeysSettingFrag = `
    id
    organizationId
    dateTo
    sendReminderToEmail
    domain
    tenantId
    clientId
`;
